import { useState } from 'react'
import { type Patient } from '@/types/patient'
import { Button, ChevronDownIcon, ChevronUpIcon, Paragraph, PassportIcon, Radio } from '@quickmd-llc/design-system'
import { ADMIN_EVENT_NAMES, tracking } from '@/lib/segment/tracking'
import { ComplianceBadge } from '../ComplianceBadge'
import { AccountCardDetails } from '../AccountCard/AccountCardDetails'

type Props = {
  patient: Patient
}

export function MergeAccountCard({ patient }: Props) {
  const [detailsOpen, setDetailsOpen] = useState<boolean>(false)

  const { FirstName, LastName, MedicalRecordNumber } = patient
  const patientName = `${FirstName} ${LastName}`

  function handleClickDetailsToggle() {
    if (!detailsOpen) {
      tracking.trackEvent(ADMIN_EVENT_NAMES.MERGE_ACCOUNTS_MERGE_ACCOUNT_DETAILS_EXPAND_ACCOUNT_DETAILS)
    }

    setDetailsOpen(!detailsOpen)
  }

  return (
    <div className='p-4'>
      <div className='grid grid-cols-[min-content_auto_min-content] items-center gap-sp-1'>
        <Radio value={patient.PatientId} />

        <div className='grid gap-sp-0.25'>
          <Paragraph className='text-text-dark'>{patientName}</Paragraph>

          <div className='flex items-center gap-sp-1'>
            <PassportIcon className='text-text-medium' />

            <Paragraph size='xs'>MRN - {MedicalRecordNumber}</Paragraph>
          </div>

          <ComplianceBadge patient={patient} />
        </div>

        <Button priority='tertiary' onClick={() => handleClickDetailsToggle()}>
          {detailsOpen ?
            <ChevronUpIcon />
          : <ChevronDownIcon />}
        </Button>
      </div>

      {detailsOpen ?
        <div className='ml-sp-5 mt-sp-2'>
          <AccountCardDetails patient={patient} />
        </div>
      : null}
    </div>
  )
}
